import React from 'react';
import { Button, Space, Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export interface BatchAction {
  key: string;
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  danger?: boolean;
  disabled?: boolean;
}

interface BatchActionToolbarProps {
  selectedCount: number;
  actions: BatchAction[];
  onClearSelection?: () => void;
  className?: string;
}

const BatchActionToolbar: React.FC<BatchActionToolbarProps> = ({
  selectedCount,
  actions,
  onClearSelection,
  className = '',
}) => {
  const { t } = useTranslation();
  
  // 如果没有选中项，不显示工具栏
  // if (selectedCount === 0) {
  //   return null;
  // }

  // 将操作分为主要操作和更多操作
  const mainActions = actions.slice(0, 3);
  const moreActions = actions.slice(3);

  // 构建更多操作的菜单项
  const moreMenuItems = moreActions.length > 0 ? 
    moreActions.map(action => ({
      key: action.key,
      icon: action.icon,
      label: action.label,
      onClick: action.onClick,
      danger: action.danger,
      disabled: action.disabled,
    }))
  : [];

  return (
    <div className={`batch-action-toolbar ${className}`}>
      <span className="selected-count">{t('common.selectedItems', { count: selectedCount })}</span>
      <Space>
        {mainActions.map(action => (
          <Button
            key={action.key}
            type={action.danger ? 'primary' : 'default'}
            danger={action.danger}
            icon={action.icon}
            onClick={action.onClick}
            disabled={action.disabled}
          >
            {action.label}
          </Button>
        ))}
        {moreMenuItems.length > 0 && (
          <Dropdown menu={{ items: moreMenuItems }}>
            <Button>
              {t('common.moreActions')} <DownOutlined />
            </Button>
          </Dropdown>
        )}
        {onClearSelection && (
          <Button type="link" onClick={onClearSelection}>
            {t('common.cancelSelection')}
          </Button>
        )}
      </Space>
    </div>
  );
};

export default BatchActionToolbar;